import React from 'react';
const tomos = [{
  icon: '🟢',
  name: 'Tomo 1 — JARDÍN DE FÚTBOL (4-5 años)',
  desc: 'Coordinación, dominio básico y primer contacto con el juego. Sin filas.'
}, {
  icon: '🟡',
  name: 'Tomo 2 — LOS CIMIENTOS (6-7 años)',
  desc: 'Pase, control orientado, remate y primera introducción al 2 vs 1.'
}, {
  icon: '🟠',
  name: 'Tomo 3 — EL ARTE DEL 1 VS 1 (8-9 años)',
  desc: 'Tijera, amague, protección de pelota y quite limpio. El gambeteador.'
}, {
  icon: '🔵',
  name: 'Tomo 4 — EL EQUIPO (10 años)',
  desc: 'Rombo, transiciones, pressing básico y salida limpia desde el arquero.'
}, {
  icon: '🔴',
  name: 'Tomo 5 — TÁCTICA AVANZADA (11-12 años)',
  desc: 'Pressing total, contragolpe en 2 toques y cambios de sistema.'
}, {
  icon: '⚫',
  name: 'Tomo 6 — EL MALETÍN DEL DT',
  desc: 'Planillas, protocolos, comunicación con padres y entrenamiento de arquero.'
}];
const includes = ['40 semanas planificadas', '80 sesiones redactadas', 'Correcciones por edad', 'Variantes Fácil/Medio/Pro', 'Plan B lluvia', 'Evaluación trimestral'];
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-12 px-4" data-id="element-267">
      <div className="max-w-4xl mx-auto" data-id="element-268">
        <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-8" data-id="element-269">
          Lo que <span className="text-[#00C853]" data-id="element-270">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-8" data-id="element-271">
          <div className="bg-black border border-[#00C853]/30 rounded-2xl p-5 sm:p-6" data-id="element-272">
            <h3 className="text-[#00C853] text-lg sm:text-xl font-black mb-1" data-id="element-273">
              ⚽ 4 a 12 años — 6 TOMOS
            </h3>
            <p className="text-gray-400 text-xs sm:text-sm mb-4" data-id="element-274">
              Para profes de Baby Fútbol y DTs de club de barrio
            </p>
            <div className="space-y-3" data-id="element-275">
              {tomos.map((t, i) => <div key={i} className="flex items-start gap-2 text-white" data-id="element-276">
                  <span className="text-base sm:text-lg mt-0.5" data-id="element-277">{t.icon}</span>
                  <div className="flex-1 text-sm leading-snug" data-id="element-278">
                    <span className="font-bold" data-id="element-279">{t.name}</span>
                    <span className="text-gray-400" data-id="element-280"> — {t.desc}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#00C853]/5 border border-[#00C853]/30 rounded-xl p-4 max-w-2xl mx-auto" data-id="element-281">
          <h3 className="text-[#00C853] text-sm font-black mb-2 text-center" data-id="element-282">
            Cada tomo incluye:
          </h3>
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1" data-id="element-283">
            {includes.map((item, i) => <span key={i} className="text-white text-xs font-medium" data-id="element-284">
                ✅ {item}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}